/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    GetQuestLeaderboardsResponseAllOf,
    GetQuestLeaderboardsResponseAllOfFromJSON,
    GetQuestLeaderboardsResponseAllOfFromJSONTyped,
    GetQuestLeaderboardsResponseAllOfToJSON,
    PaginatedResponse,
    PaginatedResponseFromJSON,
    PaginatedResponseFromJSONTyped,
    PaginatedResponseToJSON,
    PaginationInfo,
    PaginationInfoFromJSON,
    PaginationInfoFromJSONTyped,
    PaginationInfoToJSON,
    QuestLeaderboardProfile,
    QuestLeaderboardProfileFromJSON,
    QuestLeaderboardProfileFromJSONTyped,
    QuestLeaderboardProfileToJSON,
} from './';

/**
 * 
 * @export
 * @interface GetQuestLeaderboardsResponse
 */
export interface GetQuestLeaderboardsResponse extends PaginatedResponse {
    /**
     * 
     * @type {Array<QuestLeaderboardProfile>}
     * @memberof GetQuestLeaderboardsResponse
     */
    leaderboards: Array<QuestLeaderboardProfile>;
}

export function GetQuestLeaderboardsResponseFromJSON(json: any): GetQuestLeaderboardsResponse {
    return GetQuestLeaderboardsResponseFromJSONTyped(json, false);
}

export function GetQuestLeaderboardsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetQuestLeaderboardsResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        ...PaginatedResponseFromJSONTyped(json, ignoreDiscriminator),
        'leaderboards': ((json['leaderboards'] as Array<any>).map(QuestLeaderboardProfileFromJSON)),
    };
}

export function GetQuestLeaderboardsResponseToJSON(value?: GetQuestLeaderboardsResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        ...PaginatedResponseToJSON(value),
        'leaderboards': ((value.leaderboards as Array<any>).map(QuestLeaderboardProfileToJSON)),
    };
}


